module.exports = __webpack_public_path__ + "media/images/icons/filled/dribbble-circle-d09072acdcc4cca583bf3964c44c5cd7.svg";